module.exports = __webpack_public_path__ + "static/media/signup.e21c5f1e.jpg";